import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'media';

// Action Types
export const types = {
  GET_MEDIA: createAsyncTypes(`${KEY}/GET_MEDIA`),
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  RESET_MEDIA: `${KEY}/RESET_MEDIA`
};

// eslint-disable-next-line no-shadow
export enum MediaTypes {
  EVENT = 'event',
  VENUE = 'venue',
  GENRE = 'genre',
  ATTRACT_IMAGE = 'attract-image',
  ATTRACT_VIDEO = 'attract-video',
  INACTIVE_IMAGE = 'inactive-image',
  SPLASH_IMAGE = 'splash-image',
  LOGO_IMAGE = 'logo-image-large',
  BACKGROUND_IMAGE = 'background-image',
  PROMO_CODE_IMAGE = 'promo-code-image'
}

export interface MediaResponse {
  name: string;
  s3Name: string;
  priority: number;
}

export interface MediaState {
  readonly action: {
    readonly pending: boolean;
    readonly error: string | null;
  };
  readonly attractImage?: MediaResponse[];
  readonly attractVideo?: MediaResponse[];
  readonly event?: MediaResponse[];
  readonly venue?: MediaResponse[];
  readonly genre?: MediaResponse[];
  readonly inactiveImage?: MediaResponse[];
  readonly splashImage?: MediaResponse[];
  readonly backgroundImage?: MediaResponse[];
  readonly logoImage?: MediaResponse[];
  readonly promoCodeImage?: MediaResponse[];
}

export interface ResetAction {
  type: typeof types.RESET_ACTION;
}

export interface GetMediaParams {
  type: string;
  clientIntegrationId?: string;
  configurationId?: string;
  name?: string;
}

export interface GetMediaResponse {
  type: string;
  [MediaTypes.EVENT]?: MediaResponse[];
  [MediaTypes.VENUE]?: MediaResponse[];
  [MediaTypes.GENRE]?: MediaResponse[];
  [MediaTypes.ATTRACT_IMAGE]?: MediaResponse[];
  [MediaTypes.ATTRACT_VIDEO]?: MediaResponse[];
  [MediaTypes.INACTIVE_IMAGE]?: MediaResponse[];
  [MediaTypes.SPLASH_IMAGE]?: MediaResponse[];
  [MediaTypes.BACKGROUND_IMAGE]?: MediaResponse[];
  [MediaTypes.LOGO_IMAGE]?: MediaResponse[];
  [MediaTypes.PROMO_CODE_IMAGE]?: MediaResponse[];
}

export interface GetMediaRequest {
  type: typeof types.GET_MEDIA.REQUEST;
  payload: GetMediaParams;
}

export interface GetMediaError {
  type: typeof types.GET_MEDIA.ERROR;
  payload: string;
}

export interface GetMediaPending {
  type: typeof types.GET_MEDIA.PENDING;
  payload: boolean;
}

export interface GetMediaSuccess {
  type: typeof types.GET_MEDIA.SUCCESS;
  payload: GetMediaResponse;
}

export type MediaActionTypes =
  | ResetAction
  | GetMediaParams
  | GetMediaRequest
  | GetMediaError
  | GetMediaPending
  | GetMediaSuccess;
